export default __webpack_public_path__ + "static/phi-6fed7e35224e2237a26932ce0869fa51.png";